import main from "../views/main";

export default [
  {
    path: "/main",
    name: "메인",
    component: main,
  },
];
